import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import E12Spinner from './E12Spinner';
import { useUserActivityTracker } from '@/services/events/useUserActivityTracker';

interface ProtectedRouteProps {
  children?: React.ReactNode;
  allowedUserTypes?: string[];
}

export default function ProtectedRoute({
  children,
  allowedUserTypes,
}: ProtectedRouteProps) {
  const { status, tokenData, checkAuth } = useAuthStore();
  useUserActivityTracker();

  useEffect(() => {
    if (status === 'idle') {
      checkAuth();
    }
  }, [status, checkAuth]);

  if (status === 'loading' || status === 'idle') {
    return <E12Spinner />;
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/signin" replace />;
  }

  if (allowedUserTypes && tokenData?.userType) {
    if (!allowedUserTypes.includes(tokenData.userType)) {
      return <Navigate to="/not-found" replace />;
    }
  }

  return children ? <>{children}</> : <Outlet />;
}
